import { ErrorCode, AppError } from '@/types/errors';

/**
 * Creates a handler to retry media permissions
 */
export function handleRetryPermissions(deps: {
  requestMediaAccess: () => Promise<boolean | void>;
  setError: (error: AppError | null) => void;
}) {
  return async () => {
    try {
      deps.setError(null);
      await deps.requestMediaAccess();
    } catch (error) {
      console.error('Failed to get media permissions on retry:', error);
      deps.setError({ code: ErrorCode.NoLocalStream });
    }
  };
}